import { render } from "./MaterialIcon.vue?vue&type=template&id=2ab82f81&scoped=true&lang=pug"
import script from "./MaterialIcon.vue?vue&type=script&lang=ts"
export * from "./MaterialIcon.vue?vue&type=script&lang=ts"

import "./MaterialIcon.vue?vue&type=style&index=0&id=2ab82f81&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2ab82f81"

export default script